import { FormInstance } from "antd/es/form";
import React from "react";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Header2_ScreenContext } from "../header2/header2-context";

declare let window: any;

export interface IWarehouseTransferList_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IWarehouseTransferList_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
}

export class WarehouseTransferList_ScreenBase extends React.PureComponent<
  IWarehouseTransferList_ScreenProps,
  any
> {
  static contextType = Header2_ScreenContext;
  declare context: React.ContextType<typeof Header2_ScreenContext>;
  warehousetransferlist_937692_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "776d2348-ba04-4fe3-a6b5-af9a784cd104",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 894978, PropertyName: "value", Value: "Depolar Arası Transfer" },
        { Id: 570603, PropertyName: "value", Value: "Toplam Transfer" },
        { Id: 334944, PropertyName: "value", Value: "label" },
        { Id: 775, PropertyName: "value", Value: "Devam Eden" },
        { Id: 800750, PropertyName: "value", Value: "label" },
        { Id: 489177, PropertyName: "value", Value: "Tamamlanan" },
        { Id: 593570, PropertyName: "value", Value: "label" },
        { Id: 857683, PropertyName: "value", Value: "İptal edilen" },
        { Id: 762298, PropertyName: "value", Value: "label" },
        { Id: 620647, PropertyName: "value", Value: "Fiş Oluştur" },
        { Id: 517724, PropertyName: "value", Value: "Transfer Numarası" },
        { Id: 15924, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 971925, PropertyName: "title", Value: "Title" },
        { Id: 311499, PropertyName: "value", Value: "Transfer Kodu" },
        { Id: 339512, PropertyName: "value", Value: "label" },
        { Id: 533841, PropertyName: "value", Value: "label" },
        { Id: 789318, PropertyName: "value", Value: "Sayılan Ürün Sayısı" },
        { Id: 982471, PropertyName: "value", Value: "label" },
        { Id: 798196, PropertyName: "value", Value: "Durum" },
        { Id: 214651, PropertyName: "value", Value: "label" },
        { Id: 973362, PropertyName: "value", Value: "Gönderen Ofis Kodu" },
        { Id: 823536, PropertyName: "value", Value: "label" },
        { Id: 318050, PropertyName: "value", Value: "Gönderen Depo Kodu" },
        { Id: 695009, PropertyName: "value", Value: "label" },
        { Id: 634264, PropertyName: "value", Value: "label" },
        { Id: 451546, PropertyName: "value", Value: "Gelen Ofis Kodu" },
        { Id: 3042, PropertyName: "value", Value: "label" },
        { Id: 837845, PropertyName: "value", Value: "Gelen Depo Kodu" },
        { Id: 941330, PropertyName: "value", Value: "label" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.warehousetransferlist_15924_value_kuikaTextInputRef =
      React.createRef();
    this.warehousetransferlist_937692_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "warehousetransferlist",
        "header2_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "warehousetransferlist",
      "header2_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "warehousetransferlist",
      "header2_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
